export const GET_TODAY_COUNT_LOG = "GET_COUNT_LOG";
export const GET_TODAY_COUNT_LOG_SUCCESS = "GET_COUNT_LOG_SUCCESS";
export const GET_TODAY_COUNT_LOG_ERROR = "GET_COUNT_LOG_ERROR";